import SweetAlert from "react-bootstrap-sweetalert";
import { SweetAlertProps } from "react-bootstrap-sweetalert/dist/types";
import './styles.css'

export default function Alert(props: SweetAlertProps): JSX.Element {
    return <SweetAlert {...props} />
}